<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="con"><a id="page_vii"></a><strong><em>Contents</em></strong></h2>
<p class="toc-chap"><a class="nounder" href="#/xhtml/foreword#foreword"><em>Foreword</em></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/part01#part01"><em>Part One Critical</em></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch01"><em>Must We Burn Sade? by Simone de Beauvoir</em></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch02#ch02"><em>Nature as Destructive Principle by Pierre Klossowski</em></a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part02#part02" title="Link target outside of Sample"><em>Part Two from Les Crimes de l’ Amour</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><em>Reflections on the Novel (1800)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><em>Villeterque’s Review of Les Crimes de l’Amour (1800)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><em>The Author of Les Crimes de l’Amour to Villeterque, Hack Writer (1803)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><em>Florville and Courval, or The Works of Fate (1788)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part03#part03" title="Link target outside of Sample"><em>Part Three The 120 Days of Sodom (1785)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part04#part04" title="Link target outside of Sample"><em>Part Four Theater</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><em>Oxtiern, or The Misfortunes of Libertinage (1800)</em></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><em>Ernestine, A Swedish Tale (1788)</em></span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/bibliography#bibliography" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="noindent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5e993be4